import { User } from './models/user.model';

/**
* Helper class for displaying API errors back to the user
*/
export class APIError {
    hasError: boolean = false;
    errorMessage: string = 'Unknown error';
}

/**
 * Describes a single RAG value
 */
export class RAGValue {
    name: string;
    value: number;
    colour: string;
}

/**
 * Describes a comment passed during the data load state change
 */
export class DataLoadComment {
    user: User;
    comment: string;
    commentDate: string;
}

/**
 * Describes list of comment associated with a data load
 */

export class DataLoadCommentList {
    commentsList: Array<DataLoadComment>;
}

/**
 * Describes a pagination object
 */
export class Pagination {
    hasNext: Boolean;
    hasPrev: false;
    nextNum: number;
    page: number;
    pages: number;
    perPage: number;
    prevNum: number;
    total: number;
}
